import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './title-bar.scss'

class TitleBar extends Component {
    constructor(props) {
        super(props)

        this.state = { isActive: undefined }
    }

    componentDidMount() {
        // If the user does not focus on the EVE Launcher themselves
        // display the title bar in one second
        setTimeout(() => {
            if (this.state.isActive === undefined) {
                this.setState({ isActive: false })
            }
        }, 1000)

        // When window gains focus, lighten the title bar
        window.onfocus = () => {
            this.setState({ isActive: true })
        }

        // When window loses focus, darken the title bar
        window.onblur = () => {
            this.setState({ isActive: false })
        }
    }

    render() {
        const className = styles({
            titleBar: true, // Base class always applied
            animIn: this.state.isActive !== undefined, // Apply animation if isActive is defined
            inactive: !this.state.isActive, // If inactive we add the inactive class to the array,
        })

        return (
            <div className={className}>
                <div className={styles['inner-below']}>
                    <div className={styles.left} />
                    <div className={styles.right} />
                    <div className={styles['title-text']}>
                        {this.props.title}
                    </div>
                </div>
                <div className="inner">
                    <div className={styles.left} />
                    <div className={styles.right} />
                </div>
            </div>
        )
    }
}

TitleBar.propTypes = {
    title: PropTypes.string,
}

export default TitleBar



// WEBPACK FOOTER //
// ./src/components/TitleBar/title-bar.js